import { render, staticRenderFns } from "./PatientNextStepsWizard.vue?vue&type=template&id=33180e49&scoped=true"
import script from "./PatientNextStepsWizard.vue?vue&type=script&lang=js"
export * from "./PatientNextStepsWizard.vue?vue&type=script&lang=js"
import style0 from "./PatientNextStepsWizard.vue?vue&type=style&index=0&id=33180e49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33180e49",
  null
  
)

export default component.exports